import React, { useEffect, useState } from "react";
import { getAllActive } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function CampaignTenantUpdatePage(props) {
    const [campaign, setCampaign] = useState(null);
    const [tenant, setTenant] = useState(null);
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("tenant/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available Tenants");
            } else {
                setTenant(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("campaign/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available campaigns");
            } else {
                setCampaign(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (campaign && tenant) {
            setInputs([
                {
                    inputType: inputType.SELECT,
                    labelText: "Campaign",
                    required: true,
                    inputId: "campaign_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(campaign, "name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Tenant",
                    required: true,
                    inputId: "tenant_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(tenant, "external_id")
                }
            ])
        }
    }, [tenant, campaign])

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"campaign-tenant/update"}
            pageTitle={"Update Campaign Tenant"}
            isUpdate={true}
            getEndpoint={"campaign-tenant/read"}
            entityName={"Campaign Tenant"} />
    )
}

export default CampaignTenantUpdatePage;